export const columnsDataDevelopment = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "TECH",
    accessor: "tech",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsDataCheck = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataColumns = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
  {
    Header: "QUANTITY",
    accessor: "quantity",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
];

export const columnsDataComplex = [
  {
    Header: "NAME",
    accessor: "name",
  },
  {
    Header: "STATUS",
    accessor: "status",
  },
  {
    Header: "DATE",
    accessor: "date",
  },
  {
    Header: "PROGRESS",
    accessor: "progress",
  },
];

export const columnsAssetTable = [
  {
    Header: "Host/IP",
    accessor: "host",
  },
  {
    Header: "Hostname",
    accessor: "hostname",
  },
  {
    Header: "Operating System",
    accessor: "os",
  },
  {
    Header: "CVE",
    accessor: "cve",
  },
  {
    Header: "Description",
    accessor: "name",
  },
  {
    Header: "Protocol",
    accessor: "protocol",
  },
  {
    Header: "Risk Factor",
    accessor: "risk_score",
  },
  {
    Header: "VPR Score",
    accessor: "cve_score",
  },
  {
    Header: "Host Risk",
    accessor: "host_risk",
  },
  {
    Header: "Computed Value",
    accessor: "computed_value",
  },
];

export const columnsCVETable = [
  {
    Header: "CVE",
    accessor: "cve",
  },
  {
    Header: "Host",
    accessor: "host",
  },
  {
    Header: "Hostname",
    accessor: "hostname"
  },
  {
    Header: "Protocol",
    accessor: "protocol",
  },
  {
    Header: "CVE Score",
    accessor: "cvss_base_score",
  },
  {
    Header: "Risk Score",
    accessor: "host_risk",
  },
  {
    Header: "AIVRM Score",
    accessor: "computed_value"
  },
  {
    Header: "Business Line",
    accessor: "business_unit_name"
  },
  {
    Header: "Business Impact ($)",
    accessor: "log_data.asset_revenue_impacted_per_outage"
  },
];
